export default __webpack_public_path__ + "static/media/hubspot.7643ae37.png";